const API = process.env.REACT_APP_BACKEND_URL;

const MAX_DELTA_MS = 30000; // cap a single accumulation window

export function initHomeAnalytics(root) {
  if (!root) return () => {};
  let sid;
  try {
    sid = sessionStorage.getItem('aos_mkt_sid');
    if (!sid) {
      sid = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      sessionStorage.setItem('aos_mkt_sid', sid);
    }
  } catch (_e) { sid = 'anon'; }

  const dwell = {};
  const active = {}; // name -> start timestamp (only while tab visible)
  const visibleSections = new Set();
  let ctaEvents = [];

  const closeTimer = (name, now) => {
    if (active[name] == null) return;
    dwell[name] = (dwell[name] || 0) + Math.min(now - active[name], MAX_DELTA_MS);
    delete active[name];
  };

  const io = new IntersectionObserver((entries) => {
    const now = performance.now();
    entries.forEach((e) => {
      const name = e.target.dataset.label;
      if (!name) return;
      if (e.isIntersecting) {
        visibleSections.add(name);
        if (document.visibilityState === 'visible') active[name] = now;
      } else {
        visibleSections.delete(name);
        closeTimer(name, now);
      }
    });
  }, { threshold: 0.35 });
  root.querySelectorAll('[data-label]').forEach((s) => io.observe(s));

  const onClick = (e) => {
    const el = e.target.closest('[data-track]');
    if (el) ctaEvents.push({ kind: 'cta', name: el.dataset.track, ms: 0 });
  };
  document.addEventListener('click', onClick, true);

  const collect = () => {
    const now = performance.now();
    Object.keys(active).forEach((n) => {
      dwell[n] = (dwell[n] || 0) + Math.min(now - active[n], MAX_DELTA_MS);
      active[n] = now;
    });
    const secEvents = Object.entries(dwell)
      .filter(([, ms]) => ms >= 500)
      .map(([name, ms]) => ({ kind: 'section', name, ms: Math.round(ms) }));
    Object.keys(dwell).forEach((k) => delete dwell[k]);
    return [...secEvents, ...ctaEvents.splice(0)];
  };

  const flush = () => {
    const events = collect();
    if (!events.length) return;
    const payload = JSON.stringify({ session_id: sid, events });
    try {
      // text/plain avoids CORS preflight; backend parses raw body
      const ok = navigator.sendBeacon(`${API}/api/metrics/home`, new Blob([payload], { type: 'text/plain' }));
      if (!ok) throw new Error('beacon rejected');
    } catch (_e) {
      fetch(`${API}/api/metrics/home`, { method: 'POST', body: payload, keepalive: true }).catch(() => {});
    }
  };

  const iv = setInterval(flush, 15000);
  const onVis = () => {
    const now = performance.now();
    if (document.visibilityState === 'hidden') {
      // Stop all timers so hidden-tab time is never billed as dwell
      Object.keys(active).forEach((n) => closeTimer(n, now));
      flush();
    } else {
      visibleSections.forEach((n) => { active[n] = now; });
    }
  };
  document.addEventListener('visibilitychange', onVis);

  return () => {
    flush();
    clearInterval(iv);
    io.disconnect();
    document.removeEventListener('click', onClick, true);
    document.removeEventListener('visibilitychange', onVis);
  };
}
